/// <reference path="../typings/globals/jquery/index.d.ts" />
//import './case_search_s/style.scss';
import { caseSearchCommon } from "./case_search_s/common";

interface Window {
  caseSearch(containerId: string, perPage: number, jsonData: any): void;
}
declare var window: Window;

window.caseSearch = (containerId, perPage, jsonData) => {
  new caseSearchCommon(containerId, perPage, jsonData);
};
